import Vue from 'vue'
import Element from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import locale from 'element-ui/lib/locale/lang/en'
import '@/assets/styles/index.scss'
import '@/assets/styles/element-variables.scss'
import '@/assets/iconfont/iconfont.css'
// import 'element-ui/lib/theme-chalk/index.css'

// 适配移动端
import 'lib-flexible'

// 动画库，npm install animate.css --save安装，再引入
import animated from 'animate.css'
Vue.use(animated)

import NoData from '@/components/noData/noData'

Vue.config.productionTip = false

Vue.use(Element, { size: 'small' })

Vue.component('no-data', NoData)

Vue.use(Element, { locale })

Vue.prototype.device = 'pc'
if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  Vue.prototype.device = 'mobile'
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
